import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import styles from './style.module.scss';
const ClientLatencyChart = ({ values, barCount }) => {
    const { max, bars } = useMemo(() => {
        const padded = Array.from({ length: barCount }, (_, index) => values[index] ?? 0);
        const peak = Math.max(...padded, 1);
        return { max: peak, bars: padded };
    }, [values, barCount]);
    const barWidth = 0.85;
    const barGap = (1 - barWidth) / 2;
    const barClassName = (index) => {
        if (index === 0) {
            return styles.barGreen;
        }
        if (index <= 2) {
            return styles.barYellow;
        }
        return styles.barRed;
    };
    return (_jsx("div", { className: styles.chartContainer, children: _jsx("svg", { className: styles.chart, viewBox: `0 0 ${barCount} ${max}`, preserveAspectRatio: "none", children: bars.map((value, index) => (_jsx("rect", { x: index + barGap, y: max - value, width: barWidth, height: value, className: barClassName(index), children: _jsx("title", { children: value }) }, index))) }) }));
};
export default ClientLatencyChart;
